import type { PrivacyState } from './types';

const initialState: PrivacyState = {
  categoryData: {},
  categoryOrder: [],
  consentData: {},
  consents: {},
  hasDeferredUpdate: false,
  showPrompt: false,
};

export default initialState;
